import { ApiRoutes } from 'projects/admin/src/app/core/services/http/ple/api-routes.config';
import { environment } from 'projects/admin/src/environments/environment';

export const getApiServiceUrl = (apiName: string) =>
  `${environment.apiUrl.adminService}/${ApiRoutes.serviceUrls.publicPath}/${ApiRoutes.serviceUrls.version2}/${ApiRoutes.plePrefix}_${apiName}`;

export const getCommonApiServiceUrl = (apiName: string) =>
  `${environment.apiUrl.commonService}/${ApiRoutes.serviceUrls.publicPath}/${ApiRoutes.serviceUrls.version2}/${apiName}`;

export const getFileUploadServiceUrl = (apiName: string) =>
  `${environment.apiUrl.adminService}/${ApiRoutes.serviceUrls.publicPath}/${ApiRoutes.serviceUrls.version2}/${apiName}`;
